import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchBonusPoints, updateBonusPoints } from '../../slices/pointSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faSave, faCancel } from '@fortawesome/free-solid-svg-icons';
import Pagination from '../../components/Pagination';
import EditableTable from '../../components/EditableTable';
import Modal from '../../components/Modal';
import ChangeLog from '../../components/ChangeLog';

const Points = () => {
  const dispatch = useDispatch();
  const { points, status, error } = useSelector((state) => state.bonusPoint);
  const [currentPage, setCurrentPage] = useState(1);
  const [editRowId, setEditRowId] = useState(null); // Track which row is in edit mode
  const [editedData, setEditedData] = useState({}); // Store temporary data for edited row

  const itemsPerPage = 4;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = Array.isArray(points.result) ? points.result?.slice(indexOfFirstItem, indexOfLastItem) : [];
  const totalPages = Array.isArray(points.result) ? Math.ceil(points.result?.length / itemsPerPage) : 0;
  const editableFields = ['Point', 'detail', 'is_active' ]
  
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentLog,setCurrentLog] = useState([]);
  
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
  

  useEffect(() => {
    dispatch(fetchBonusPoints());
  }, [dispatch]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleEdit = (rowId) => {
    setEditRowId(rowId);
    const rowData = points.result?.find((user) => user.id === rowId);
    setEditedData(rowData); // Pre-fill the fields with current row data
  };

  const handleSave = async () => {
    // Extract only id, point, and detail for the API call
    const { id, Point, detail, is_active } = editedData;
    const updatedData = { id, Point, detail, is_active  };
    await dispatch(updateBonusPoints(updatedData));
    dispatch(fetchBonusPoints());

    setEditRowId(null); // Exit edit mode after saving
  };

  const handleCancel = () => {
    setEditRowId(null); // Exit edit mode and reset data
    setEditedData({}); // Reset to original data
  };

  const handleLog = (id)=>{
    const logData = points?.Change_Log?.filter((f)=>f.id===id)[0]?.oldTrack;
    setCurrentLog(logData)
    openModal()
  }

  const handleChange = (e, field,val) => {
    if(field==="is_active" || field==="status"){
      setEditedData((prev) => ({
        ...prev,
        [field]:!val,
      }));
    }else{
      setEditedData((prev) => ({
        ...prev,
        [field]:e.target.value,
      }));
    }
};



  const headers = points.result?.length > 0 ? Object.keys(points.result[0]).filter((key) => key !== 'id') : [];

  if (status === 'loading') {
    return <div>Loading...</div>;
  }

  if (status === 'failed') {
    return <div>Error: {error}</div>;
  }

  if (!points || points.length === 0) {
    return <div>No data available</div>;
  }

  return (
    <div className="pt-14 w-full flex items-center flex-col">
      <h1 className="text-center m-4 text-xl font-semibold">Bonus Points</h1>
      <div className='max-w-[90%]'>
      <EditableTable
        headers={headers}
        rows={currentItems}
        editRowId={editRowId}
        editedData={editedData}
        handleEdit={handleEdit}
        handleSave={handleSave}
        handleCancel={handleCancel}
        handleChange={handleChange}
        handleLog={handleLog}
        editableFields={editableFields} // Pass editable fields
      />
      </div>
     
  <div className="flex mt-4 items-center justify-between w-11/12">

<Pagination
  currentPage={currentPage}
  setCurrentPage={setCurrentPage}
  totalPages={totalPages}
/>
</div>
<Modal
        isOpen={isModalOpen}
        onClose={closeModal}
        title="Change Log"
        content={<ChangeLog data={currentLog}/>}
      />
    </div>
  );
};

export default Points;
